import Component from "../../../../js/assets/component.js"
import ButtonFavorite from "../../atoms/button/button_favorite.js"
import Util from "../../../../js/assets/util.js"

class TourListAjaxPagination extends Component{
  constructor(selector) {
    // set root element
    super(selector)
  }

  data() {
    return {
      "otherProductsBaseUrl": '',
      "assetsBaseUrl": '',
      "addFavoriteBaseUrl": '',
      "removeFavoriteBaseUrl": '',
      "productDetailBaseUrl": '',
      "otherProducts": [],
      "pages": [],
      "pageno": 1,
      "listType": 'small',
    }
  }

  changed(){
    return {
      "listType": (type)=>{
        this.switchListView(type)
        this.switchButtonView(type)
      },
      "pageno": (next, prev)=>{
        this.getPageOf(next)
      },
    }
  }

  activate(){
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
  }

  switchButtonView(type){
    switch(type){
      case "small":
        this.$buttonSmall.addClass("-active")
        this.$buttonFull.removeClass("-active")
        break
      case "full":
        this.$buttonSmall.removeClass("-active")
        this.$buttonFull.addClass("-active")
        break
    }
  }

  switchListView(type){
    switch(type){
      case "small":
        this.$tourListSmall.addClass("-active")
        this.$tourListFull.removeClass("-active")
        break
      case "full":
        this.$tourListSmall.removeClass("-active")
        this.$tourListFull.addClass("-active")
        break
    }
  }

  update() {
    this.$tourListSmall.find('.tourList_items').empty()
    this.$tourListFull.find('.tourListFull_items').empty()

    this.$data.otherProducts.forEach((productInfo) => {
      this.createSmallListContent(productInfo)
      this.createFullListContent(productInfo)
    })

    this.createPaginationContent(this.$data.pages)
  }

  createSmallListContent(productInfo) {
    let $small = this.createSmallItem()
    this.insertDataToSmallItem($small, productInfo)
    this.$tourListSmall.find('.tourList_items').append($small)
  }

  createFullListContent(productInfo) {
    let $full = this.createFullItem()
    this.insertDataToFullItem($full, productInfo)
    this.$tourListFull.find('.tourListFull_items').append($full)
  }

  createPaginationContent(pages) {
    let $paginationWrapper = this.$el.find('.tourListAjaxPagination_pagination')
    $paginationWrapper.empty()

    // ほかのページがないとき
    if (pages.pageCount <= 1) {
      return
    }

    let $pagination = this.createPagination()
    this.insertDataToPagination($pagination, this.$data.pages)

    $paginationWrapper.append($pagination)
  }

  updatePageno(event) {
    this.$data.pageno = event.currentTarget.dataset.pageNo
    event.preventDefault()
  }

  insertDataToPagination($pagination, pages) {
    if (pages.hasOwnProperty('previous')) {
      let $prev = $pagination.find('.pagination_prev')
      $prev.addClass('-active')
      $prev.attr('data-page-no', pages.previous)
      $prev.on('click', (event) => {
        this.$data.pageno = event.currentTarget.dataset.pageNo
        event.preventDefault()
      })
    }

    if (pages.hasOwnProperty('next')) {
      let $next = $pagination.find('.pagination_next')
      $next.addClass('-active')
      $next.attr('data-page-no', pages.next)
      $next.on('click', (event) => {
        this.$data.pageno = event.currentTarget.dataset.pageNo
        event.preventDefault()
      })
    }

    // ボタンを並べる。
    pages.pagesInRange.forEach((pageNo) => {
      let $button = $(
        `
        <li class="pagination_item">
          <span class="bg"></span>
          <a class="pagination_item_link" href="#" data-page-no="${pageNo}"> ${pageNo} </a>
        </li>`
      )

      $button.find('.pagination_item_link').on('click', (event) => {
        this.$data.pageno = event.currentTarget.dataset.pageNo
        event.preventDefault()
      })

      if (pageNo === pages.current) {
        $button.addClass('-active')
      }

      $pagination.find('.pagination_items').append($button)
    })

    return $pagination
  }

  insertDataToSmallItem($item, info) {
    $item.find('.tourList_item_link').attr({'href': this.$data.productDetailBaseUrl + info.id})

    if (info.new) {
      $item.find('.bg').after($('<span>', { 'class': 'labelNew'}).text('NEW'))
    }

    if (info.img) {
      $item.find('.tourList_item_img').css({backgroundImage: `url(${this.$data.assetsBaseUrl + info.img})`})
    }
    $item.find('.tourList_item_departureDate').text(info.departure_date)

    let $points = $item.find('.tourList_item_point')
    info.point.forEach((p) => {
      $points.append(
        $('<span>').text(p)
      )
    })

    $item.find('.tourList_item_catch').text(info.catch)
    $item.find('.tourList_item_price').text(info.price)
    $item.find('.description').text(info.description_list)
  }

  insertDataToFullItem($item, info) {
    if (info.new) {
      $item.prepend($('<span>', { 'class': 'labelNew'}).text('NEW'))
    }

    if (info.departure_date) {
      $item.find('.tourCode').after($(`<p class="paragraph"><strong>[ 出発日指定 ]</strong> ${info.departure_date}</p>`))
    }

    // お気に入りボタン設定
    let $favorite = $item.find('.buttonFavorite_root')
    if (info.is_favorite) {
      $favorite.removeClass('buttonFavorite')
      $favorite.addClass('buttonFavorite-added')
    }
    $favorite.attr('data-productId',info.id)

    // ButtonFavoriteの実装に合わせ、falseの場合空文字をセットする
    $favorite.attr('data-isFavorite', (info.is_favorite || ""))
    $favorite.attr('data-addUrl', this.$data.addFavoriteBaseUrl + info.id)
    $favorite.attr('data-removeUrl', this.$data.removeFavoriteBaseUrl + info.id)

    new ButtonFavorite($favorite)

    $item.find('.tourCode_code').text(info.tourCode)

    // 商品名、「ツアー情報を見る」ボタン、非表示箇所、3箇所のリンクを設定
    $item.find('.tourName_link').attr('href', this.$data.productDetailBaseUrl + info.id)
    $item.find('.tourName_wrapper').append($('<h3>').text(info.catch))

    // 画像設定
    let imagePath = info.img ? this.$data.assetsBaseUrl + info.img : ""
    let $imageSpan = $('<span>', {css: {
        "background-image": `url(${imagePath})`
      }})
    $item.find('.tourListFull_item_point_img').append($imageSpan)

    // ツアーのポイント
    if (info.point) {
      let $pointItems = $('<ul>', {class: "tourPoint_items"})
      info.point.forEach((p) => {
        $pointItems.append($('<li>', {class: "tourPoint_item"}).text(p))
      })
      let $point = $('<div>', {class: "tourPoint"}).append($pointItems)
      $item.find('.tourListFull_item_point_img').after($point)
    }

    // 画像設定
    let tourImagePath = info.img ? this.$data.assetsBaseUrl + info.img : ""
    let $tourImageSpan = $('<span>', {css: {
        "background-image": `url(${tourImagePath})`
      }})
    $item.find('.tourListFull_item_outline_img').append($tourImageSpan)

    let $table = $item.find('.tableNoBorder')
    if(info.description_list) {
      $table.find('tbody').prepend($('<tr>').append($('<td>', {attr: {colspan: 2}}).text(info.description_list)))
    }
    $table.find('.price').text(info.price)
    if (info.FuelSurchargeIncludeStatus.isIncluded) {
      $table.find('.tourListFull_item_price').html(`${$table.find('.tourListFull_item_price').html()}<br>※燃油サーチャージ含む`)
    }
    if (info.FuelSurchargeIncludeStatus.isExcluded) {
      $table.find('.tourListFull_item_price').html(`${$table.find('.tourListFull_item_price').html()}<br>※燃油サーチャージ別`)
    }

    $table.find('.tourListFull_item_departureAirport').text(info.departure_airport)
    $table.find('.tourListFull_item_period').text(info.period + '日間')
    $table.find('.tourListFull_item_airline').text(info.airline)

    // エスケープしつつbrを出したい
    $table.find('.tourListFull_item_hotels').html(info.hotels.map((hotel) => Util.sanitize(hotel)).join('<br>'))
  }

  createSmallItem() {
    let $card = $('<li>', {'class': 'tourList_item'})
      .append($('<a>', {'class': 'tourList_item_link', 'href': "#"})
        .append($('<span>', {'class': 'bg'}))
        .append($('<div>', {'class': 'tourList_item_img'}))
        .append($('<div>', {'class': 'tourList_item_departureDate'}))
        .append($('<div>', {'class': 'tourList_item_point'}))
        .append($('<h4>', {'class': 'tourList_item_catch'}))
        .append($('<div>', {'class': 'tourList_item_price'}))
        .append($('<p>', {'class': 'description'}))
      )

    return $card
  }

  createFullItem() {
    const elm = `
  <li class="tourListFull_item">
    <div class="tourListFull_item_header">
      <dl class="tourCode">
        <dt class="tourCode_label">ツアーコード</dt>
        <dd class="tourCode_code"></dd>
      </dl>
      <p class="paragraph"></p>

    <div class="buttonFavorite buttonFavorite_root" data-productid="" data-isfavorite="" data-addurl="" data-removeurl="">
      <div class="buttonFavorite_wrap">
        <span class="buttonFavorite_bg"></span>
          <span class="buttonFavorite_icon">
            <span class="buttonFavorite_icon-add"></span>
            <span class="buttonFavorite_icon-remove"></span>
          </span>
          <span class="buttonFavorite_label">
            <span class="buttonFavorite_label-add">お気に入りに登録</span>
            <span class="buttonFavorite_label-remove">お気に入りから削除</span>
          </span>
        </div>
      </div>
    </div>

    <a class="tourName_link" href="">
      <div class="tourName">
        <div class="tourName_wrapper">
          <h3></h3>
        </div>
      </div>
    </a>

    <div class="tourListFull_item_point">
      <span class="tourListFull_item_point_img"></span>


      <div class="button-primary " id="">
        <a class="tourName_link" href="">
          <span class="button_wrapper">
            <span class="button_bg"></span>
            <span class="button_label">ツアー情報を見る</span>
          </span>
        </a>
      </div>
    </div>

    <div class="tourListFull_item_outline">
      <span class="tourListFull_item_outline_img"></span>
      <table class="tableNoBorder">
        <tbody>
          <tr>
            <th>旅行代金<br>[1名1室]</th>
            <td class="tourListFull_item_price">
              <span class="price"></span>
            </td>
          </tr>
          <tr>
            <th>出発地</th>
            <td class="tourListFull_item_departureAirport"></td>
          </tr>
          <tr>
            <th>日数</th>
            <td class="tourListFull_item_period"></td>
          </tr>
          <tr>
            <th>航空会社</th>
            <td class="tourListFull_item_airline"></td>
          </tr>
          <tr>
            <th>宿泊ホテル</th>
            <td class="tourListFull_item_hotels"></td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="tourListFull_item_footer">
      <div class="button-primary ">
        <a class="tourName_link" href="">
          <span class="button_wrapper">
            <span class="button_bg"></span>
            <span class="button_label">ツアー情報を見る</span>
          </span>
        </a>
      </div>
    </div>
  </li>`
    let $card = $(elm)

    return $card
  }

  createPagination() {
    const elm = `
    <div class="pagination">
      <a class="pagination_prev" href="#">
        <span class="icon_arrow-left"></span>
      </a>
      <ul class="pagination_items">
      </ul>
      <a class="pagination_next" href="#">
        <span class="icon_arrow-right"></span>
      </a>
</div>
    `
    return $(elm)
  }

  reloadPage() {
    console.log('時間経過のためトークン有効期限が切れている可能性があります、リロードします')

    const message = 'ページの有効期限が切れている可能性があります。5秒後にページをリロードします。'
    Util.alert(message)

    setTimeout(() => { window.location.reload() }, 5000)
  }

  async getPageOf(pageno) {
    let that = this

    let response

    try {
      response = await $.ajax({
        url: this.$data.otherProductsBaseUrl + String(pageno),
        type: "GET",
        dataType: 'json',
      })

      that.$data.otherProducts = response.otherProducts
      that.$data.pages = response.pages

      this.update()
    } catch (error) {
      console.error('「その他のツアー」取得時にサーバーとの通信でエラーが発生しました', error)
      Util.alert('「その他のツアー」取得時にエラーが発生しました')
      if (error.status === 403) {
        // トークンが古くなっている可能性あり
        this.reloadPage()
        return
      }

      // 上に伝播させる
      throw error
    }

    return response
  }

  getBaseUrl(url) {
    return url.replace(/0$/, '')
  }

  // can access this.el or this.$el
  mounted() {
    this.$detail = $("[data-comp='Detail']")
    this.$buttonSmall = this.$el.find(".buttonListSmall")
    this.$buttonFull = this.$el.find(".buttonListFull")
    this.$tourListSmall = this.$el.find(".tourListSmall")
    this.$tourListFull = this.$el.find(".tourListFull")

    this.$buttonSmall.on("click", ()=>{
      this.$data.listType = "small"
    })
    this.$buttonFull.on("click", ()=>{
      this.$data.listType = "full"
    })

    this.$data.otherProductsBaseUrl = this.getBaseUrl(this.$detail.data('otherProductsBaseUrl'))
    this.$data.assetsBaseUrl = this.getBaseUrl(this.$detail.data('assetsBaseUrl'))
    this.$data.addFavoriteBaseUrl = this.getBaseUrl(this.$detail.data('addFavoriteBaseUrl'))
    this.$data.removeFavoriteBaseUrl = this.getBaseUrl(this.$detail.data('removeFavoriteBaseUrl'))
    this.$data.productDetailBaseUrl = this.getBaseUrl(this.$detail.data('productDetailBaseUrl'))

    // window:loadの時点だと別スクリプトにてトークンが設定済みだが、document:DOMContentLoadedの時点ではまだトークンがセットされてないので、取得する
    $.ajaxSetup({
      'headers': {
        'ECCUBE-CSRF-TOKEN': $('meta[name="eccube-csrf-token"]').attr('content')
      }
    });

    this.getPageOf(this.$data.pageno)
  }
}

// export as singleton
let instance = new TourListAjaxPagination("#tourList")

// Object.seal(instance)
export default instance
